"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDownloadFileFormat = void 0;
const immer_1 = require("immer");
const SET_FILE_FORMAT = "download_options.set_file_format";
function setDownloadFileFormat(format) {
    return {
        type: SET_FILE_FORMAT,
        format,
    };
}
exports.setDownloadFileFormat = setDownloadFileFormat;
exports.default = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return {
            format: "jpeg",
        };
    }
    switch (action.type) {
        case SET_FILE_FORMAT:
            draft.format = action.format;
            break;
        default:
            break;
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG93bmxvYWRPcHRpb25zUmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByaW50aW5nL290aGVyL2Rvd25sb2FkT3B0aW9uc1JlZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUNBQWdDO0FBTWhDLE1BQU0sZUFBZSxHQUFHLGtDQUFrQyxDQUFDO0FBRTNELFNBQWdCLHFCQUFxQixDQUFDLE1BQWM7SUFDbEQsT0FBTztRQUNMLElBQUksRUFBRSxlQUFlO1FBQ3JCLE1BQU07S0FDUCxDQUFDO0FBQ0osQ0FBQztBQUxELHNEQUtDO0FBRUQsa0JBQWUsSUFBQSxlQUFPLEVBQ3BCLENBQUMsS0FBMkIsRUFBRSxNQUFNLEVBQXdCLEVBQUU7SUFDNUQsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3ZCLE9BQU87WUFDTCxNQUFNLEVBQUUsTUFBTTtTQUNmLENBQUM7S0FDSDtJQUVELFFBQVEsTUFBTSxDQUFDLElBQUksRUFBRTtRQUNuQixLQUFLLGVBQWU7WUFDbEIsS0FBSyxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDO1lBQzdCLE1BQU07UUFDUjtZQUNFLE1BQU07S0FDVDtBQUNILENBQUMsQ0FDRixDQUFDIn0=